import { render, staticRenderFns } from "./ingredientlist.vue?vue&type=template&id=35a817d0&scoped=true&"
import script from "./ingredientlist.vue?vue&type=script&lang=js&"
export * from "./ingredientlist.vue?vue&type=script&lang=js&"
import style0 from "./ingredientlist.vue?vue&type=style&index=0&id=35a817d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a817d0",
  null
  
)

export default component.exports